<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="schedule-filtering"
			title="スケジュールフィルタリング"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<div class="modal-header-schedule-filtering">
					<v-btn flat blue large color="white" v-on:click="onClickDone">登録</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClickClear">クリア</v-btn>
				</div>
			</template>
			<template v-if="showContent">
				<v-form ref="form-schedule-filtering">
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs10 class="label">
						表示期間
					</v-flex>
					<v-flex xs5 class="label">
						<v-menu
							ref="beginCalendar"
							v-model="beginCalendar"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
						<template v-slot:activator="{ on }">
						  <v-text-field
							v-model="value.begin"
							label="開始日"
							v-on="on"
							readonly 
							clearable
						  ></v-text-field>
						</template>
						<v-date-picker
							v-model="value.begin"
							no-title
							@input="beginCalendar = false"
							locale="jp-ja"
							:day-format="date => new Date(date).getDate()"
							:min="beginPastPeriod"
							:max="beginFuturePeriod"
						></v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs1 class="label">
						～
					</v-flex>
					<v-flex xs5 class="label">
						<v-menu
							ref="endCalendar"
							v-model="endCalendar"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
						<template v-slot:activator="{ on }">
						  <v-text-field
							v-model="value.end"
							label="終了日"
							v-on="on"
							readonly 
							clearable
						  ></v-text-field>
						</template>
						<v-date-picker 
							v-model="value.end" 
							no-title 
							@input="endCalendar = false" 
							locale="jp-ja" 
							:day-format="date => new Date(date).getDate()"
							:min="endPastPeriod"
							:max="endFuturePeriod"
						></v-date-picker>
						</v-menu>
					</v-flex>
				</v-layout>
				<div class="error-display-area ml-2">
					<span v-if="error" class="red--text text-center flex xs12">{{ error }}</span>
				</div>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="multi-line-label">
						案件
					</v-flex>
					<v-flex xs8 class="content">
						<GBProjects
							:items="value.projects"
							:max_width=176
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-on:click="onClickShowProjectSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>

					<v-flex xs12 v-for="info in additionalInfo" v-bind:key="info.additional_info.code">
						<v-layout>
							<v-flex sm2 mt-3 class="label">{{ info.additional_info.name }}</v-flex>
							<v-flex sm10 mt-3 class="content">
								<template v-if="info.additional_info.isNumber">
									<v-text-field
										v-model="info.additional_data.min"
										:maxlength="info.additional_info.max_length"
										:rules="info.additional_info.createAdditionalInfoFilteringRules()"
										counter
									></v-text-field>
									<div class="label mt-4">
										～
									</div>
									<v-text-field
										v-model="info.additional_data.max"
										:maxlength="info.additional_info.max_length"
										:rules="info.additional_info.createAdditionalInfoFilteringRules()"
										counter
									></v-text-field>
								</template>
								<template v-else>
									<v-text-field
										v-model="info.additional_data.name"
										:maxlength="info.additional_info.max_length"
										:rules="info.additional_info.createAdditionalInfoFilteringRules()"
										counter
									></v-text-field>
								</template>
							</v-flex>
						</v-layout>
					</v-flex>

				</v-layout>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="multi-line-label">
						メンバー
					</v-flex>
					<v-flex xs8 class="content">
						<GBMembers
							:items="value.members"
							:max_width=176
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-on:click="onClickShowMemberSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="multi-line-label">
						分類
					</v-flex>
					<v-flex xs8 class="content">
						<GBClasses
							:items="value.classes"
							:max_width=176
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-on:click="onClickShowClassSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="multi-line-label">
						案件色
					</v-flex>
					<v-flex xs8 class="content">
						<GBColors
							:items="value.color_project"
							:max_width="176"
							:all_show=true
							:type="typeColor.PROJECT"
							:select_type="typeSelect.MULTIPLE"
						/>
						<v-btn
							flat
							fab
							class="btn-add-color"
							v-on:click="onClickShowProjectColorSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="multi-line-label">
						メンバー色
					</v-flex>
					<v-flex xs8 class="content">
						<GBColors
							:items="value.color_member"
							:max_width="176"
							:all_show=true
							:type="typeColor.MEMBER"
							:select_type="typeSelect.MULTIPLE"
						/>
						<v-btn
							flat
							fab
							class="btn-add-color"
							v-on:click="onClickShowMemberColorSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-2 mx-2 class="row-group">
					<v-flex xs4 class="label">
						アラートのみ
					</v-flex>
					<v-flex xs8 class="content">
					<v-switch
						v-model="value.alert"
					></v-switch>
					</v-flex>
				</v-layout>
				</v-form>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBClasses from './GBClasses';
import GBMembers from './GBMembers';
import GBProjects from './GBProjects';
import GBColors from './GBColors';
import { UNIT_WIDTH, FETCH_PERIOD_RANGE, COLOR_SELECT_TYPE} from '../data/Const';
const strftime = require('strftime');
import Color from '../data/Color';

const clonedeep = require('lodash/cloneDeep');

export default {
	name: 'GBRightPaneScheduleFiltering',
	props: [
		"value",
		"selected_class",
		"color_selected_filtering_project",
		"color_selected_filtering_member",
	],
	data: function (){
		return {
			beginCalendar: false,
			endCalendar: false,
			beginPastPeriod: '',
			beginFuturePeriod: '',
			endPastPeriod: '',
			endFuturePeriod: '',
			
			dataset_manager: this.$store.getters.datasetManager,
			error: '',
			typeColor: Color.RELATION_TYPE,
			typeSelect: COLOR_SELECT_TYPE,
		};
	},
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBClasses,
		GBProjects,
		GBMembers,
		GBColors,
	},
	methods: {
		onClose: function() {
			this.beginCalendar = false;
			this.endCalendar = false;
			this.error = '';
			this.resetPeriod();
			
			this.$emit('close');
		},
		onClickShowProjectSelect: function() {
			this.$emit('show-project-select', this.value.projects);
		},
		onClickShowMemberSelect: function() {
			this.$emit('show-member-select', this.value.members);
		},
		onClickShowClassSelect: function() {
			this.$emit('show-class-select', clonedeep(this.value.classes));
		},
		onClickShowProjectColorSelect: function() {
			this.$emit('show-color-select', {
				color: clonedeep(this.value.color_project),
				type: Color.RELATION_TYPE.PROJECT,
				select_type: this.typeSelect.MULTIPLE,
			});
		},
		onClickShowMemberColorSelect: function() {
			this.$emit('show-color-select', {
				color: clonedeep(this.value.color_member),
				type: Color.RELATION_TYPE.MEMBER,
				select_type: this.typeSelect.MULTIPLE,
			});
		},
		clearAdditionalInfoData: function() {
			this.value.additional_info_data.forEach(data => {
				data.name = '';
				data.min = '';
				data.max = '';
			});
		},
		onClickClear: function() {
			this.value.projects = [];
			this.value.members = [];
			this.value.begin = null;
			this.value.end = null;
			this.value.classes = [];
			this.value.color_project = [];
			this.value.color_member = [];
			this.value.alert = false;
			this.value.status = this.$store.getters.scheduleFilter.status;
			this.error = '';
			this.resetPeriod();
			this.clearAdditionalInfoData()

			this.beginCalendar = false;
			this.endCalendar = false;
			
		},
		resetPeriod: function() {
			this.beginPastPeriod = '';
			this.beginFuturePeriod = '';
			this.endPastPeriod = '';
			this.endFuturePeriod = '';
		},
		updateScheduleFilter: async function() {
			if (this.value === null) {
				this.onClose();
				return;
			}
			const filtering_additional_data = this.value.additional_info_data.filter(data => {
				return data.name || data.min || data.max;
			});
			this.value.additional_info_data = filtering_additional_data;
			this.$store.dispatch('updateScheduleFilter', this.value);
			
			let filter_begin;
			let filter_end;
			if (this.value.begin != null) 
				filter_begin = new Date(this.value.begin);
			if (this.value.end != null) 
				filter_end = new Date(this.value.end);
			let base_date = this.$store.getters.baseDate;
			let end_date = this.$store.getters.endDate;
			let display_period = this.$store.getters.displayPeriod;
			
			if (filter_begin != null && filter_end != null) {
				let term_day = (filter_end - filter_begin) / 86400000;
				if (term_day < display_period.default)
					filter_end.setDate(filter_end.getDate() + (display_period.default - term_day));
			} else if (filter_begin != null && filter_end == null) {
				let term_day = (end_date - filter_begin) / 86400000;
				if (term_day < display_period.default) {
					filter_end = clonedeep(filter_begin);
					filter_end.setDate(filter_end.getDate() + display_period.default);
				} else {
					filter_end = clonedeep(end_date);
				}
			} else if (filter_begin == null && filter_end != null) {
				let term_day = (filter_end - base_date) / 86400000;
				if (term_day < display_period.default) {
					filter_begin = clonedeep(filter_end);
					filter_begin.setDate(filter_end.getDate() - display_period.default);
				} else {
					filter_begin = clonedeep(base_date);
				}
			}
			
			let scroll_date;
			if (this.value.begin != null)
				scroll_date = {
					date: clonedeep(filter_begin),
					shift: 4,
				};
			else if (this.value.end != null) {
				let width = this.$store.getters.width;
				let shift = Math.round((width / UNIT_WIDTH.DAY) - 12);
				scroll_date = {
					date: clonedeep(filter_end),
					shift: shift,
				};
			}
			if (filter_begin)
				filter_begin.setDate(filter_begin.getDate() - display_period.expand);
			if (filter_end)
				filter_end.setDate(filter_end.getDate() + display_period.expand);
			
			if (filter_begin < base_date || filter_end > end_date) {
				var begin_year = filter_begin.getFullYear();
				var begin_month = filter_begin.getMonth() + 1;
				var begin_day = filter_begin.getDate();
				if (begin_month < 10)
					begin_month = '0' + begin_month;
				if (begin_day < 10)
					begin_day = '0' + begin_day;
				let begin = `${begin_year}${begin_month}${begin_day}`;
				
				var end_year = filter_end.getFullYear();
				var end_month = filter_end.getMonth() + 1;
				var end_day = filter_end.getDate();
				if (end_month < 10)
					end_month = '0' + end_month;
				if (end_day < 10)
					end_day = '0' + end_day;
				let end = `${end_year}${end_month}${end_day}`;

				this.$emit('fetch-data', {
					force_update: true,
					period: {
						begin: begin,
						end: end,
					},
					callback: () => {
						if (scroll_date) {
							this.$nextTick(() => {
								this.$store.dispatch('moveDay', scroll_date);
							});
						}
					},
				});
			} else {
				if (scroll_date)
					this.$store.dispatch('moveDay', scroll_date);
			}
			
			this.onClose();
		},
		onClickDone: function() {
			if (this.value.begin != null && this.value.end != null){ 
				if (this.value.begin > this.value.end){
					this.error = '日付を確認してください';
					return;
				}
			}
			const form = this.$refs['form-schedule-filtering'];
			if (!form.validate())
				return;
			this.updateScheduleFilter();
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		showContent: function() {
			if (!this.value)
				return false;
			
			return true;
		},
		additionalInfo: function() {
			if(!this.value)
				return [];
				
			const ret = [];
			this.$store.getters.additionalInfo.forEach(add => {
				const data = this.value.additional_info_data.filter(i => {
					return i.code == add.code;
				});
				if (data.length > 0) {
					ret.push({
						additional_info : add,
						additional_data : data[0],
					});
				}
			});

			return ret;
		},
	},
	watch: {
		'value.begin': function() {
			if (this.value !== undefined && this.value !== null){
				if (this.value.begin !== null){
					this.endPastPeriod = this.value.begin;
					var dt = new Date(this.value.begin);
					dt.setFullYear(dt.getFullYear() + FETCH_PERIOD_RANGE.YEAR);
					this.endFuturePeriod = strftime('%Y-%m-%d',dt);
				} else {
					this.endPastPeriod = '';
					this.endFuturePeriod = '';
				}
			}
		},
		'value.end': function() {
			if (this.value !== undefined && this.value !== null){
				if (this.value.end !== null){
					this.beginFuturePeriod = this.value.end;
					var dt = new Date(this.value.end);
					dt.setFullYear(dt.getFullYear() - FETCH_PERIOD_RANGE.YEAR);
					this.beginPastPeriod = strftime('%Y-%m-%d',dt);
				} else {
					this.beginFuturePeriod = '';
					this.beginPastPeriod = '';
				}
			}
		},
		color_selected_filtering_project: function() {
			if (this.value !== undefined && this.value !== null && this.color_selected_filtering_project !== null) {
				if (this.color_selected_filtering_project.length > 0) {
					this.value.color_project = this.color_selected_filtering_project.map(c => {
						let color = this.$store.getters.masterColor.find(mc => mc.code === c.code);
						return new Color(Object.assign(Object.assign({}, color)));
					}).filter(c => {
						return c.code !== undefined;
					});
				} else {
					this.value.color_project = [];
				}
			}
		},
		color_selected_filtering_member: function() {
			if (this.value !== undefined && this.value !== null && this.color_selected_filtering_member !== null) {
				if (this.color_selected_filtering_member.length > 0) {
					this.value.color_member = this.color_selected_filtering_member.map(c => {
						let color = this.$store.getters.masterColor.find(mc => mc.code === c.code);
						return new Color(Object.assign(Object.assign({}, color)));
					}).filter(c => {
						return c.code !== undefined;
					});
				} else {
					this.value.color_member = [];
				}
			}
		},
		selected_class: function() {
			if (this.value !== undefined && this.value !== null && this.selected_class !== null) {
				if (this.selected_class.length > 0) {
					this.value.classes = this.selected_class.filter(c => {
						let cls = this.$store.getters.masterClass.find(mc => mc.code === c.code);
						if (cls === undefined)
							return false;
						return true;
					});
				} else {
					this.value.classes = [];
				}
			}
		},
	}
}
</script>
<style>
	.modal-window.schedule-filtering .row-group {
		min-height: 60px;
	}
	.modal-window.schedule-filtering .row {
		
	}
	.modal-window.schedule-filtering .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.schedule-filtering .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.schedule-filtering .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.schedule-filtering .modal-header-schedule-filtering {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.schedule-filtering .btn-add-class, .modal-window.schedule-filtering .btn-add-color	{
		height: 24px;
		width: 24px;
		margin-top: 0px;
	}
	.modal-window.schedule-filtering .error-display-area {
		height: 24px;
	}
</style>
